import React from 'react'
import {
  DateTimeInput,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  Create,
  useNotify,
  useRedirect,
  useInput,
  NumberInput,
  BooleanInput,
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { client } from './../../provider/MbaasClient'
import productOrigin from './../list-product-origin'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextFieldMui from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'

import { RaNumberFormatInput } from './../../shared-components'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flexGrow: 1,
  },
  input: {
    marginBottom: '-20px',
  },
  tes: {
    backgroundColor: 'red',
    '.MuiListItem-root.Mui-selected .MuiListItem-root.Mui-selected:hover': {
      backgroundColor: 'red',
    },
  },
  tes2: {
    border: '1px solid black',
    borderRadius: '5%',
    backgroundColor: 'lightgrey',
    '& ul': {
      backgroundColor: 'red',
    },
    '& li': {
      fontSize: 12,
    },
  },
  test: {
    '& ul li[aria-selected="true"]:after': {
      content: "'\\2713'",
      marginLeft: 'auto',
    },
  },
}))

export const FlashsaleCreate = ({ ...props }) => {
  const classes = useStyles()
  const notify = useNotify()
  const redirect = useRedirect()

  const [optionCategory, setOptionCategory] = React.useState([])
  const [optionProdCode, setOptionProdCode] = React.useState([])

  const [selectedProdOrigin, setSelectedProdOrigin] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState([])
  const [selectedProdCode, setSelectedProdCode] = React.useState([])

  const [firstRender, setFirstRender] = React.useState(true)

  React.useEffect(() => {
    let haloTimeout = setTimeout(() => {
      client
        .invokeApi('promo-flashsales-products', {
          product_origin: selectedProdOrigin.map((v) => v.id), //[String],
          // product_origin: ['MYS'], //[String],
          // category: formData.category || ['ALL'], //[String],
          // product_code: '', //[String],
          // denomination: '', //Int,
          invoked: 'category', //String! product_origin, category, product_code, denomination
        })
        .then((v) => {
          if (v.length !== 0) {
            const category = v.data?.data?.map((v) => ({ id: v.category, name: v.category }))
            setOptionCategory(category)
            !firstRender && setSelectedCategory(category)
          }
        })
    }, 2000)

    return () => clearTimeout(haloTimeout)
  }, [firstRender, selectedProdOrigin])

  React.useEffect(() => {
    let haloTimeout = setTimeout(() => {
      client
        .invokeApi('promo-flashsales-products', {
          product_origin: selectedProdOrigin.map((v) => v.id), //[String],
          category: selectedCategory.map((v) => v.id), //[String],
          // product_code: '', //[String],
          // denomination: '', //Int,
          invoked: 'product_code', //String! product_origin, category, product_code, denomination
        })
        .then((v) => {
          if (v.length !== 0) {
            const prodCode = v.data?.data?.map((v) => ({
              id: v.product_code,
              name: v.product_code,
            }))
            setOptionProdCode(prodCode)
            !firstRender && setSelectedProdCode(prodCode)
          }
        })
    }, 2000)

    return () => clearTimeout(haloTimeout)
  }, [firstRender, selectedCategory, selectedProdOrigin])

  const onSuccess = () => {
    notify('ra.notification.created', 'info', { smart_count: 1 })
    redirect('/flashsale')
  }

  return (
    <Create title="Create Flashsale" {...props} onSuccess={onSuccess}>
      <SimpleForm>
        <SelectInput
          label="Country"
          source="country"
          fullWidth
          validate={required()}
          choices={[
            // { id: 'ALL', name: 'All Country' },
            { id: 'MY', name: 'Malaysia' },
            { id: 'ID', name: 'Indonesia' },
          ]}
        />
        <CustomAutocompleteProductOrigin
          label="Product Origin"
          source="product_origin"
          validate={required()}
          selectedProdOrigin={selectedProdOrigin}
          setSelectedProdOrigin={setSelectedProdOrigin}
          setSelectedCategory={setSelectedCategory}
          setSelectedProdCode={setSelectedProdCode}
          firstRender={firstRender}
          setFirstRender={setFirstRender}
          //
        />
        <CustomAutocompleteCategory
          label="Category"
          source="category"
          validate={required()}
          option={optionCategory}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setSelectedProdCode={setSelectedProdCode}
          firstRender={firstRender}
          setFirstRender={setFirstRender}

          //
        />
        <CustomAutocompleteProductCode
          label="Product Code"
          source="product_code"
          validate={required()}
          option={optionProdCode}
          selectedProdCode={selectedProdCode}
          setSelectedProdCode={setSelectedProdCode}
          firstRender={firstRender}
          setFirstRender={setFirstRender}
          //
        />
        <RaNumberFormatInput
          label="Denomination"
          source="denomination"
          fullWidth
          style={{ marginBottom: '28px' }}
        />
        <TextInput label="Value" source="value" placeholder="" fullWidth />

        <div style={{ display: 'flex', width: '100%', margin: '6px 0' }}>
          <BooleanInput
            fullWidth
            source="apply_max_usage_per_customer"
            label="Apply Cust. Max Usage?"
            title="Is Max Usage per Customer applied?"
            style={{ flexGrow: 1 }}
            defaultValue={true}
          />
          <FormDataConsumer subscription={{ values: true }}>
            {({ formData, ...rest }) => {
              if (formData.apply_max_usage_per_customer) {
                return (
                  <NumberInput
                    style={{ flexGrow: 1 }}
                    className={classes.input}
                    source="max_usage_per_customer"
                    label="Max Usage per Customer"
                    defaultValue={1}
                  />
                )
              }
            }}
          </FormDataConsumer>
        </div>
        <div style={{ display: 'flex', width: '100%', margin: '6px 0' }}>
          <BooleanInput
            fullWidth
            source="new_customer_only"
            label="For New Customer / Target Only?"
            title="Customer / Target without success transactions before this promo is created"
            style={{ flexGrow: 1 }}
          />

          <BooleanInput
            fullWidth
            source="specific_target"
            label="Is Specific Target?"
            title="Is it can only be used once per target?"
            style={{ flexGrow: 1 }}
            defaultValue={true}
          />
        </div>
        <div style={{ display: 'flex', width: '100%', margin: '6px 0' }}>
          <BooleanInput
            style={{ flexGrow: 1 }}
            fullWidth
            source="specific_customer"
            label="Is for Specific Customer?"
            title="Is applied for Specific Customer?"
          />

          <FormDataConsumer subscription={{ values: true }}>
            {({ formData, ...rest }) => {
              if (formData?.specific_customer) {
                return (
                  <ReferenceInput
                    style={{ flexGrow: 1 }}
                    source="customer_id"
                    reference="customers"
                    fullWidth
                    className={classes.input}
                    sort={{ field: 'name', order: 'ASC' }}
                    label="Specific for"
                  >
                    <AutocompleteInput
                      source="name"
                      optionText={(choice) => `${choice?.name} - ${choice?.channel_id}`}
                    />
                  </ReferenceInput>
                )
              }
            }}
          </FormDataConsumer>
        </div>

        <RaNumberFormatInput
          label="Total Usage"
          source="total_usage"
          fullWidth
          style={{ marginBottom: '28px' }}
        />

        <div style={{ width: '100%', display: 'flex', gap: 16 }}>
          <DateTimeInput
            label="Valid From"
            source="start"
            fullWidth
            className={classes.input}
            validate={[required()]}
          />
          <DateTimeInput
            label="Valid Until"
            source="end"
            fullWidth
            className={classes.input}
            validate={[required()]}
          />
        </div>
      </SimpleForm>
    </Create>
  )
}

const CustomAutocompleteProductCode = (props) => {
  const classes = useStyles()
  const [tes, setTes] = React.useState(true)
  const {
    input: { name, onChange, ...rest },
    meta: { touched, error },
    isRequired,
  } = useInput(props)

  const record = props.record[name]

  React.useEffect(() => {
    !props.firstRender && onChange(props.selectedProdCode)
  }, [onChange, props.firstRender, props.selectedProdCode])

  React.useEffect(() => {
    if (record) {
      const tes = record.map((v) => ({
        id: v,
        name: v,
      }))
      props.setSelectedProdCode(tes)
    }
  }, [props, record])

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      value={
        props.firstRender && tes
          ? props.option.filter((item) => record.includes(item.id))
          : props.selectedProdCode
      }
      style={{ marginBottom: '32px' }}
      onChange={(_, v) => {
        onChange(v)
        setTes(false)
        // props.setFirstRender(false)
        props.setSelectedProdCode(v)
      }}
      required={isRequired}
      PaperComponent={({ children }) => <Paper className={classes.test}>{children}</Paper>}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select ${name.toLowerCase()}`}
          error={!!(touched && error)}
          helperText={touched && error && 'required'}
          {...rest}
        />
      )}
    />
  )
}

const CustomAutocompleteCategory = (props) => {
  const classes = useStyles()
  const {
    input: { name, onChange, ...rest },
    meta: { touched, error },
    isRequired,
  } = useInput(props)

  const record = props.record[name]

  React.useEffect(() => {
    if (record) {
      const tes = record.map((v) => ({
        id: v,
        name: v,
      }))
      props.setSelectedCategory(tes)
    }
  }, [props, record])

  React.useEffect(() => {
    !props.firstRender && onChange(props.selectedCategory)
  }, [onChange, props.firstRender, props.selectedCategory])

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      value={
        props.firstRender
          ? props.option.filter((item) => {
              return record.includes('ALL') ? true : record.includes(item.id)
            })
          : props.selectedCategory
      }
      style={{ marginBottom: '32px' }}
      onChange={(_, v) => {
        // onChange(v)
        props.setFirstRender(false)
        props.setSelectedCategory(v)
        props.setSelectedProdCode([])
      }}
      required={isRequired}
      PaperComponent={({ children }) => <Paper className={classes.test}>{children}</Paper>}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select ${name.toLowerCase()}`}
          error={!!(touched && error)}
          helperText={touched && error && 'required'}
          {...rest}
        />
      )}
    />
  )
}

const CustomAutocompleteProductOrigin = (props) => {
  const classes = useStyles()
  const {
    input: { name, onChange, ...rest },
    meta: { touched, error },
    isRequired,
  } = useInput(props)

  const record = props.record[name]

  React.useEffect(() => {
    !props.firstRender && onChange(props.selectedProdOrigin)
  }, [onChange, props.firstRender, props.selectedProdOrigin])

  React.useEffect(() => {
    if (record) {
      const tes = productOrigin.filter((item) => record.includes(item.id))
      props.setSelectedProdOrigin(tes)
    }
  }, [props, record])

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={productOrigin}
      getOptionLabel={(option) => option.name}
      value={props.selectedProdOrigin}
      style={{ marginBottom: '32px' }}
      onChange={(_, v) => {
        // onChange(v)
        props.setSelectedProdOrigin(v)
        props.setFirstRender(false)
        props.setSelectedCategory([])
        props.setSelectedProdCode([])
      }}
      required={isRequired}
      PaperComponent={({ children }) => <Paper className={classes.test}>{children}</Paper>}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select ${name.toLowerCase()}`}
          error={!!(touched && error)}
          helperText={touched && error && 'required'}
          {...rest}
        />
      )}
    />
  )
}
